export default __webpack_public_path__ + "static/media/wide.0b548acd.webp";